import appLocaleData from 'react-intl/locale-data/ko';
import koMessages from '../locales/ko-KO';

const KoLang = {
    messages: {
        ...koMessages
    },
    locale: 'ko-KO',
    data: appLocaleData
};
export default KoLang;